import type { LanguageFn } from 'highlight.js';
import bash from 'highlight.js/lib/languages/bash';
import css from 'highlight.js/lib/languages/css';
import diff from 'highlight.js/lib/languages/diff';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import markdown from 'highlight.js/lib/languages/markdown';
import python from 'highlight.js/lib/languages/python';
import sql from 'highlight.js/lib/languages/sql';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';

/**
 * Grammars highlighted in published code blocks (highlight.js) and in the rich
 * editor (lowlight). Only the languages docs actually use, so neither bundle
 * carries all ~190. Each grammar brings its own aliases (js, ts, sh, html, yml,
 * md, …). Token colors live in styles/syntax.css.
 */
export const SYNTAX_LANGUAGES: Record<string, LanguageFn> = {
  bash,
  css,
  diff,
  javascript,
  json,
  markdown,
  python,
  sql,
  typescript,
  xml,
  yaml,
};
